import { CircularProgress } from '@mui/material';
import { useTranslation } from 'react-i18next';
import {
  DialogCancelButton,
  DialogPrimaryButton,
  RagStorageModalActions,
} from '../styled';

interface FormActionsProps {
  isEditMode: boolean;
  isSubmitting: boolean;
  disabled: boolean;
  onCancel: () => void;
  onSubmit: () => void;
}

const FormActions = ({
  isEditMode,
  isSubmitting,
  disabled,
  onCancel,
  onSubmit,
}: FormActionsProps) => {
  const { t } = useTranslation('common');

  return (
    <RagStorageModalActions>
      <DialogCancelButton
        onClick={onCancel}
        data-testid="context-dialog-cancel-btn"
      >
        {t('assistant.ragStorageDialog.cancel')}
      </DialogCancelButton>
      <DialogPrimaryButton
        onClick={onSubmit}
        disabled={disabled}
        data-testid="context-dialog-submit-btn"
        startIcon={
          isSubmitting ? (
            <CircularProgress size={16} color="inherit" />
          ) : undefined
        }
      >
        {!isEditMode
          ? t('assistant.ragStorageDialog.createItem')
          : t('assistant.ragStorageDialog.saveChanges')}
      </DialogPrimaryButton>
    </RagStorageModalActions>
  );
};

export default FormActions;
